// removed by extract-text-webpack-plugin
module.exports = {"root":"footer--root--1kX451xF","container":"footer--container--3da7hQQs","info":"footer--info--37n24XSs","logo":"footer--logo--3xD9a0cW","contact":"footer--contact--2eQqnlnv","social-media":"footer--social-media--1SJy229m","socialMedia":"footer--social-media--1SJy229m","icon":"footer--icon--yGKbvrrG","fb":"footer--fb--2kt3eAwT","tw":"footer--tw--ycSBiWC7","ig":"footer--ig--fKlJbhmH","version":"footer--version--cLikfnDe"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/styles.css
// module id = ./components/footer/styles.css
// module chunks = 0